export default __webpack_public_path__ + "static/media/limb_main_mobile_small@2x.d0685e3b.jpg";